import React from 'react';
import { motion } from 'motion/react';
import styles from './EmptyState.module.css';
import Button from './Button';
import { SPRING, staggerContainer, staggerItem } from '../../utils/motion';

const container = staggerContainer(0.08, 0.05);
const iconVariant = {
  hidden: { opacity: 0, scale: 0.6 },
  visible: { opacity: 1, scale: 1, transition: SPRING.bouncy },
};

export default function EmptyState({
  title = 'Sin resultados',
  description,
  actionLabel,
  onAction,
  icon,
}) {
  return (
    <motion.div
      className={styles.wrap}
      variants={container}
      initial="hidden"
      animate="visible"
    >
      {icon && (
        <motion.div className={styles.icon} variants={iconVariant}>
          {icon}
        </motion.div>
      )}
      <motion.h3 className={styles.title} variants={staggerItem}>
        {title}
      </motion.h3>
      {description && (
        <motion.p className={styles.desc} variants={staggerItem}>
          {description}
        </motion.p>
      )}
      {actionLabel && onAction && (
        <motion.div variants={staggerItem}>
          <Button variant="primary" onClick={onAction}>
            {actionLabel}
          </Button>
        </motion.div>
      )}
    </motion.div>
  );
}
